var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"stroke":"#fff","strokeLinecap":"round","strokeWidth":"3","d":"M11.5706 30.6625l19.0918-19.0919M11.7639 11.5707l19.0919 19.0919","key":1})]);
}

Close.defaultProps = {"fill":"none","viewBox":"0 0 43 43"};

module.exports = Close;

Close.default = Close;
